import React   from "react";
import { Pagination, FileList } from "@components";
import { Input, DateInput, Select } from "@components/form";
import { useForm, FormProvider } from 'react-hook-form';

const Notice = () => {
  const methods = useForm();

  return (
    <FormProvider {...methods}>
      {/* <form onSubmit={methods.handleSubmit(onSubmit)}> */}
        <div className="contents-wrap">
          <div className="page-title-wrap">
            <h2><span className="icon-dot-circle"></span>회원 목록</h2>
          </div>

          <div className="tab-cont-wrap">
            <div className="tab-cont-01 on">
              <div className="search-wrap">
                <div className="search-row">
                  <div className="search-item date-picker-box">
                    <label>등록일</label>
                      <DateInput name="createStDate" />
                      <span className="separator">~</span>
                      <DateInput name="createEndDate" />
                      {/* <DateInput name="createEndDate" minDate={watch("createStDate")} /> */}
                  </div>
                  {/* 
                  <div className="search-item">
                    <Radio label="예시1번" name="exm" value="e1" />
                    <Radio
                      label="예시2번"
                      name="exm"
                      value="e2"
                      className="ml10"
                    />
                  </div> */}
                  <div className="search-item">
                    <Select
                      name="searchCnd"
                      options={[
                        { key: "0", name: "제목" },
                        { key: "1", name: "내용" },
                      ]}
                      defaultOption="선택"
                      className="input-select"
                    />

                        {/* <Select
                            name="bizRegNo"
                            options={companyList}
                            defaultOption="업체를 선택하세요"
                            required
                            className="inp-sel-sub"
                            valueKey="bizRegNo" // key 값 (value)
                            labelKey="corpName" // 텍스트 보이는 이름
                            onChange={(e) => {
                              const selectedId = e.target.value;
                              setSelectedCompanyId(selectedId);
                              setValue('bizRegNo', selectedId,  { shouldValidate: true }); 
                            }}
                          /> */}

                    <Input
                      name="searchWrd"
                      placeholder="검색어를 입력하세요"
                      className="input-search"
                      style={{ width: "250px" }}
                    />
                  </div>
                  <div className="search-btn-container">
                    <button className="btn-search">조회</button>
                  </div>
                </div>
              </div>

                <section>
                  <div className="section-tit-wrap">
                    <h3 className="border-left-primary">
                      &nbsp;산업안전보건법
                      <span className="total-txt">
                        {" "} | 총 <span className="red"></span> 건
                      </span>
                    </h3>
                    <div className="btn-right-box">
                      <ul>
                        <li><a href="/main" title="엑셀" className="btn-excel" >엑셀</a></li>
                        {/* <li><a href="/" title="저장" className="btn-save" >저장</a></li> */}
                        {/* <li><a href="/" title="등록" className="btn-write"  onClick={handleRegister}>등록</a></li>
                        <li><a href="/" title="수정" className="btn-update" onClick={handleUpdate}>수정</a></li>
                        <li><a href="/" title="삭제" className="btn-delete" onClick={handleDelete}>삭제</a></li> */}
                      </ul>
                    </div>
                  </div>
                  <div className="table-container">
                  <table className="table-list" style={{width:"100%"}}>
                    <colgroup>
                      <col style={{ width: "1%" }} />
                      <col style={{ width: "3%" }} />
                      <col style={{ width: "15%" }} />
                      <col style={{ width: "5%" }} />
                      <col style={{ width: "15%" }} />
                      <col style={{ width: "5%" }} />
                      <col style={{ width: "13%" }} />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>
                        {/* <input type="checkbox" checked={isAllChecked} onChange={handleSelectAll} /> */}
                        <input type="checkbox" />
                        </th>
                        <th>번호</th>
                        <th>제목</th>
                        <th>담당자</th>
                        <th>내용</th>
                        <th>등록일</th>
                        {/* <SortHeader field="TITLE" label="제목" />
                        <SortHeader field="WRITER" label="담당자" />
                        <SortHeader field="CONTENT" label="내용" />
                        <SortHeader field="CREATED_AT" label="등록일" /> */}
                        <th>파일</th>

                      </tr>
                    </thead>
                    <tbody>
                    {/* {data?.resultList && data.resultList.length > 0 ? (
                      data.resultList.map((item, idx) => (
                        <tr 
                            key={item.boardNum}
                            onClick={() => handleSelectItem(item.boardNum)}
                            style={{ cursor: "pointer" }}>
                          <td onClick={(e) => e.stopPropagation()}>
                            <input type="checkbox" checked={selectedItems.includes(item.boardNum)} onChange={() => handleSelectItem(item.boardNum)} />
                          </td>
                          <td>{(pageIndex - 1) * recordCountPerPage + idx + 1}</td>
                          <td style={{textAlign:"left"}}>{item.title}</td>
                          <td>{item.writer}</td>
                          <td>{item.content}</td>
                          <td>{item.createdAt}</td>
                          <td><FileList atchFileId={item.atchFileId} updatedAt={item.updatedAt} showDelete={false} className="inline" onFileDelete={() => setValue("atchFileId", null)}/> </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={7} style={{ textAlign: 'center' }}>
                          조회 결과가 없습니다.
                        </td>
                      </tr>
                    )} */}
                  </tbody>
                  </table>
                  </div>
                    {/* {data?.paginationInfo && data.paginationInfo.totalRecordCount > 0 && (
                    <Pagination
                        totalPages={Math.ceil(
                        data.paginationInfo.totalRecordCount / data.paginationInfo.recordCountPerPage
                        )}
                        currentPage={pageIndex}
                        onPageChange={handlePageChange}
                        pageRangeDisplayed={10}
                    />
                    )} */}
                </section>
            </div>
          </div>
        </div>
      {/* </form> */}
    </FormProvider>
  );
};

export {Notice};
